import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import useLoginStyles from './useLoginStyles';
import useLogin from '../../hooks/useLogin';
import useGlobalStyles from '../useGlobalStyles';

/**
 * Login Component contains a form that allows the user to input their username, which is then submitted
 * to the application's context through the useLoginContext hook.
 */
const Login = () => {
  const { classes } = useLoginStyles();
  const { classes: globalClasses } = useGlobalStyles();

  const {
    username,
    password,
    handleSubmit,
    handleInputChange,
    handleCreateAccountNav,
    status,
    error,
  } = useLogin();

  return (
    <div className={classes.container}>
      <div className={`${globalClasses.h2} ${classes.welcome}`}>
        Welcome to{' '}
        <img
          src={`${process.env.PUBLIC_URL}/assets/branding/login-logo.png`}
          alt='Logo'
          className={classes.logo}
        />
        !
      </div>
      <div className={classes.sectionContainer}>
        <div className={`${globalClasses.h3} ${classes.text}`}>Log In</div>
        <form onSubmit={handleSubmit} className={classes.form}>
          <label htmlFor='usernameInput' className={`${globalClasses.h5} ${classes.labelText}`}>
            Username
          </label>
          <input
            type='text'
            value={username}
            onChange={e => handleInputChange(e, 'username')}
            placeholder='Enter your username'
            required
            className={`${globalClasses.input} ${classes.formInput}`}
            id='usernameInput'
          />
          <label htmlFor='passwordInput' className={`${globalClasses.h5} ${classes.labelText}`}>
            Password
          </label>
          <input
            type='password'
            value={password}
            onChange={e => handleInputChange(e, 'password')}
            placeholder='Enter your password'
            required
            className={`${globalClasses.input} ${classes.formInput}`}
            id='passwordInput'
          />
          {error && (
            <p className={classes.errorMessage}>Invalid username or password. Please try again.</p>
          )}
          <Button
            type='submit'
            className={`${globalClasses.button} ${classes.submitButton}`}
            disabled={status === 'loading'}
            aria-busy={status === 'loading'}
            aria-label={status === 'loading' ? 'Submitting...' : 'Submit'}
            style={{ cursor: status === 'loading' ? 'none' : 'pointer' }}>
            {status === 'loading' ? (
              <CircularProgress size={'1.5rem'} style={{ color: 'white' }} />
            ) : (
              'Submit'
            )}
          </Button>
        </form>
        <div className={classes.dividerOr}>
          <hr className={classes.dividerLine} />
          <span className={classes.dividerText}>OR</span>
          <hr className={classes.dividerLine} />
        </div>
        <p className={globalClasses.h6}>Don&#39;t have an account?</p>
        <Button
          onClick={handleCreateAccountNav}
          className={`${globalClasses.button} ${classes.switchButton}`}>
          Create an Account
        </Button>
      </div>
    </div>
  );
};

export default Login;
